import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { AviationEventsService } from '../../shared/services/aviation-events.service';
var EditEventShortDescriptionComponent = /** @class */ (function () {
    function EditEventShortDescriptionComponent(_matDialogRef, data, _aviationEventsService) {
        this._matDialogRef = _matDialogRef;
        this._aviationEventsService = _aviationEventsService;
        this._MAX_CHARACTERS = 200;
        this.isBusy = false;
        this.aviationEvent = data.aviationEvent;
        this.charRemainingCnt = this.aviationEvent.shortDescription ?
            this._MAX_CHARACTERS - this.aviationEvent.shortDescription.length : this._MAX_CHARACTERS;
        this._originDesc = this.aviationEvent.shortDescription;
    }
    EditEventShortDescriptionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this._matDialogRef.close(null);
        });
        this.formGroup = new FormGroup({
            shortDescription: new FormControl('', [Validators.required, Validators.maxLength(this._MAX_CHARACTERS)])
        });
    };
    EditEventShortDescriptionComponent.prototype.cancel = function () {
        this.aviationEvent.shortDescription = this._originDesc;
        this._matDialogRef.close(null);
    };
    EditEventShortDescriptionComponent.prototype.textAreaChanged = function () {
        this.charRemainingCnt = this.aviationEvent.shortDescription.length <= this._MAX_CHARACTERS ?
            this._MAX_CHARACTERS - this.aviationEvent.shortDescription.length : 0;
    };
    EditEventShortDescriptionComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.aviationEvent.shortDescription) {
                            this.aviationEvent.shortDescription = this.aviationEvent.shortDescription.trim();
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this.isBusy = true;
                        return [4 /*yield*/, this._aviationEventsService.updateAviationEvent(this.aviationEvent)];
                    case 2:
                        _a.sent();
                        this.isBusy = false;
                        this._matDialogRef.close(true);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.isBusy = false;
                        this._matDialogRef.close(false);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return EditEventShortDescriptionComponent;
}());
export { EditEventShortDescriptionComponent };
